import React from 'react';
import SidebarTemplate from 'components/templates/SidebarTemplate';
import HopeShiftForm from 'components/organismos/master/attend/HopeShiftForm';

const HopeShiftPage: React.FC = () => (
  <SidebarTemplate>
    <HopeShiftForm />
  </SidebarTemplate>
);

export default HopeShiftPage;
